// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + {"372":"overlay","516":"vwFreespee","607":"smasi2ProfileDebuggerBootstrap"}[chunkId] + "-" + {"372":"4c462f33dd0bfe95d349ed2bb6a9876b","516":"0fa07d47e8dc59ae20af5f3d9905b162","607":"c7041c0f07a47988ab85e4bbfaf89ae9"}[chunkId] + ".static.js";
};